export default __webpack_public_path__ + "static/astrorei-team-sviluppatori-software-3b3274d805cd249f57218957525113e2.jpg";